import { useState, useEffect, useRef } from "react";
import HttpService from "../HttpService";

const BASE_URL = process.env.REACT_APP_API_URL + "SD_intern/Queues";

export function useQueues() {
    const [vhosts, setVhosts] = useState([]);
    const [queues, setQueues] = useState([]);
    const [selectedVhost, setSelectedVhost] = useState(null);
    const [selectedQueue, setSelectedQueue] = useState(null);
    const [queueDetail, setQueueDetail] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const axiosClientRef = useRef(null);

    useEffect(() => {
        const httpService = HttpService;
        httpService.configure();
        axiosClientRef.current = httpService.getAxiosClient();
    }, []);

    // Load vhosts on mount
    useEffect(() => {
        if (!axiosClientRef.current) return;

        setLoading(true);
        axiosClientRef.current
            .get(`${BASE_URL}/Vhosts`)
            .then((r) => setVhosts(r.data || []))
            .catch((e) => setError(e.toString()))
            .finally(() => setLoading(false));
    }, []);

    // Load queues when vhost changes
    useEffect(() => {
        if (!selectedVhost || !axiosClientRef.current) return;

        setQueues([]);
        setSelectedQueue(null);
        setQueueDetail(null);
        setLoading(true);

        axiosClientRef.current
            .get(`${BASE_URL}/${encodeURIComponent(selectedVhost)}/Queues`)
            .then((r) => setQueues(r.data || []))
            .catch((e) => setError(e.toString()))
            .finally(() => setLoading(false));
    }, [selectedVhost]);

    // Load queue detail when queue changes
    useEffect(() => {
        if (!selectedVhost || !selectedQueue || !axiosClientRef.current) return;

        setLoading(true);

        axiosClientRef.current
            .get(`${BASE_URL}/${encodeURIComponent(selectedVhost)}/Queues/${encodeURIComponent(selectedQueue)}`)
            .then((r) => setQueueDetail(r.data || null))
            .catch((e) => setError(e.toString()))
            .finally(() => setLoading(false));
    }, [selectedVhost, selectedQueue]);

    return {
        vhosts, queues, queueDetail,
        selectedVhost, setSelectedVhost,
        selectedQueue, setSelectedQueue,
        loading, error,
    };
}